const clickableIcons = document.getElementsByClassName("info-pop-up-icon");
const popup = document.getElementById("info-pop-up-wrapper");

Array.from(clickableIcons).forEach(function(element) {
  element.addEventListener("click", function() {
    openInfo(this);
  });
});

const body = document.body;
const popupHeader = popup.querySelector(".info-pop-up-header");
const popupImage = popup.querySelector(".info-pop-up-image");
const popupImageSrc = popup.querySelector(".info-pop-up-image-src");
const popupDescriptionOne = popup.querySelector(".info-pop-up-description-one");
const popupDescriptionTwo = popup.querySelector(".info-pop-up-description-two");
const popupProductLink = popup.querySelector(".info-pop-up-product-link");

function openInfo(element) {
  const header = element.getAttribute("data-header");
  const image = element.getAttribute("data-image");
  const descriptionOne = element.getAttribute("data-descriptionOne");
  const descriptionTwo = element.getAttribute("data-descriptionTwo");
  const productUrl = element.getAttribute("data-productUrl");

  popupHeader.textContent = header;
  popupDescriptionOne.textContent = descriptionOne;
  popupDescriptionTwo.innerHTML = descriptionTwo;

  if (image) {
    popupImageSrc.src = image;
    popupImage.style.display = "block";
  }

  // Show product link if URL is provided
  if (productUrl && popupProductLink) {
    popupProductLink.href = productUrl;
    popupProductLink.style.display = "inline-block";
  } else if (popupProductLink) {
    popupProductLink.style.display = "none";
  }

  popup.style.display = "flex";
  body.style.overflow = "hidden";

}

function closeInfoPopup(event) {  
  if(event.target.id == "close-info-pop-up" || event.target.id == "info-pop-up-wrapper") {
   popup.style.display = "none";
   body.style.overflow = "visible";
  }
}
